import * as React from 'react';
import { Heading } from '@grandvisionhq/elements';
import { BrandPromotion } from '../BrandPromotion/BrandPromotion.js';

const ProductDetailTitle = ({ title , subtitle , href , brandName , brandPromotions ,  })=>/*#__PURE__*/ React.createElement("div", {
        className: "product-detail-title"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-detail-title__subtitle-row"
    }, !!href ? /*#__PURE__*/ React.createElement("a", {
        href: href,
        className: "product-detail-title__link"
    }, subtitle) : /*#__PURE__*/ React.createElement("span", {
        className: "product-detail-title__subtitle"
    }, subtitle), brandPromotions && brandName && /*#__PURE__*/ React.createElement(BrandPromotion, {
        className: "product-detail-title__brand-promotion",
        brandName: brandName,
        brandPromotions: brandPromotions
    })), /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        component: "h1",
        className: "product-detail-title__title"
    }, title))
;

export { ProductDetailTitle };
//# sourceMappingURL=ProductDetailTitle.js.map
